import { ReactComponent as TwitterRound } from './icon.svg'

export default TwitterRound
